<template>

	<div :class="[checked ? 'checked' : '', 'focus:outline-none tw-radio-option']" @click='updateSelected'>
		<div class="flex-1 flex items-center gap-2">
			<i v-if='icon' :class="[icon, 'text-2xl mx-2']"></i>

			<div class="flex flex-col  pr-6 ">
				<div :class="[checked ? 'text-gray-700' : '', 'block text-sm text-gray-500 font-medium']">
					{{ title }}
				</div>
				<div class="mt-1 flex items-center text-sm text-gray-500">
					{{ description }}
				</div>
			</div>
		</div>
		<div v-if='checked' class="absolute top-1.5 right-1.5 ">
			<div class="flex items-center justify-center rounded-full bg-primary-light h-4 w-4">
				<i class='text-white far fa-check text-xs'></i>
			</div>
		</div>

	</div>

</template>

<script>
	export default{
		props:{
			title:{
				default:'',
			},
			description:{
				default:'',
			},
			option:{
				default:null
			},
			value:{
				default:null
			},
			selected:{
				default:null
			},
			icon:{
				default:null
			}
		},
		computed:{
			checked(){
				return this.value == this.option;
			},
		},
		data: () => ({
			selectedValue: null
		}),
		mounted(){
			if(this.value){
				this.selectedValue = this.value;
			}
		},
		methods:{
			updateSelected(){
				this.selectedValue = this.option;
				this.$emit('input', this.selectedValue);
				this.$emit('updated', this.selectedValue);

			}
		}

	}
</script>